import Button from "components/form-elements/Button";
import Input from "components/form-elements/Input";
import StaticAlert from "components/ui-elements/StaticAlert";
import { useAuth } from "context/AuthProvider";
import { LangLabel } from "data/LangLabel";
import { MyConst } from "data/MyConst";
import useAxiosFunction from "hooks/useAxiosFunction";
import LoginHeader from "layouts_element/siad/LoginHeader";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { LoadingContent } from "utils/MyUtils";

export default function Login() {
  const { login } = useAuth();
  const divalert = useRef();
  const [, error, loading, axiosFetch] = useAxiosFunction();
  const [authLoading, setAuthLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const requiredRule = { required: LangLabel.MSG_REQUIRED };

  const onSubmit = async (data) => {
    setAuthLoading(true);

    try {
      const loginResp = await axiosFetch({
        method: "POST",
        url: "/auth/login",
        data,
        timeout: 15000,
      });

      if (!loginResp?.data?.success) {
        divalert.current?.showAlert(loginResp?.message || "Login gagal.", "error");
        return;
      }

      const bootstrapResp = await axiosFetch({
        method: "GET",
        url: "/app/bootstrap",
        auth: true,
        authToken: loginResp.data.token,
        timeout: 15000,
      });

      if (bootstrapResp?.data?.user) {
        const nextUser = {
          ...loginResp.data,
          ...bootstrapResp.data.user,
          menus: bootstrapResp.data.menus || [],
          permissions: bootstrapResp.data.permissions || [],
          settings: bootstrapResp.data.settings || {},
          personal_fields: bootstrapResp.data.personal_fields || [],
          app_info: bootstrapResp.data.app || {},
        };
        login({
          ...nextUser,
          bootstrap_ready_key: `${nextUser.uid || ""}:${nextUser.id_user_group || ""}:${nextUser.version || ""}:${MyConst.BOOTSTRAP_SCHEMA_VERSION || ""}`,
        });
        return;
      }

      divalert.current?.showAlert(
        bootstrapResp?.message || "Gagal memuat aplikasi setelah login.",
        "error",
      );
    } finally {
      setAuthLoading(false);
    }
  };

  useEffect(() => {
    document.body.className = "hold-transition login-page";
    if (!divalert.current) return;

    if (error) {
      divalert.current.showAlert(error, "error");
      return;
    }
    divalert.current.showAlert("Silakan login ke aplikasi.", "default");
  }, [error]);

  return (
    <div className="login-page mylogin-page">
      <div className="login-box">
        <div className="card">
          <LoginHeader />
          <div className="card-body">
            <div className="login-box-msg mylogin-box-msg">
              <StaticAlert ref={divalert} message={error} />
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Input name="username" error={errors.username?.message} register={register} validation={requiredRule} placeholder={LangLabel.LABEL_USERNAME} icon="fa-envelope" />
              <Input
                name="password"
                type={showPassword ? "text" : "password"}
                error={errors.password?.message}
                register={register}
                validation={requiredRule}
                placeholder={LangLabel.LABEL_PASSWORD}
                icon={showPassword ? "fa-eye-slash" : "fa-eye"}
                iconTitle={showPassword ? "Sembunyikan password" : "Tampilkan password"}
                onIconClick={() => setShowPassword((current) => !current)}
              />
              <div className="row">
                <div className="col-md-12">
                  <Button loading={loading || authLoading} type="submit" title={LangLabel.LABEL_LOGIN} block={true} />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">&nbsp;</div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {(loading || authLoading) && <LoadingContent />}
    </div>
  );
}
